import type {
  ArgQueryInspectionResult,
  ArgUpsertItemInspectionResult,
  ResQueryInspectionResult,
  ResUpsertItemInspectionResult
} from '@/types/accessor/api/emergencyInspectionResult/emergencyInspectionResult'
import type { ApiConnector, IndexedDBConnector } from '@/types/accessor/common/connector'
import {
  queryEmergencyInspectionResultApi,
  upsertEmergencyInspectionResultApi
} from './requests/disasterEmergencyInspectionResultApiGwFuncs'

export const upsert: ApiConnector<
  ArgUpsertItemInspectionResult,
  ResUpsertItemInspectionResult | ResQueryInspectionResult
> = async (params: ArgUpsertItemInspectionResult, indexedDBConnector: IndexedDBConnector) => {
  const data = await upsertEmergencyInspectionResultApi(params)
  if (!params.needRecords) {
    await indexedDBConnector(params)
    return data
  }
  await indexedDBConnector(data)
  return data
}

export const query: ApiConnector<ArgQueryInspectionResult, ResQueryInspectionResult> = async (
  params: ArgQueryInspectionResult,
  indexedDBConnector
) => {
  const data = await queryEmergencyInspectionResultApi(params)
  await indexedDBConnector(data)
  return data
}
